export default __webpack_public_path__ + "static/media/arrow-down.d331800b.svg";